"use client";

import { PageNotFoundTemplate } from "@faire/retailer-visitor-shared/components/PageNotFound/PageNotFoundTemplate";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

export const NotFoundPlaceholder: React.FC = () => {
  return (
    <PageNotFoundTemplate
      title={
        <StrictLocalMsg
          defaultMessage="Sorry about that!"
          description={{
            text: "Title for a page not found",
            img: "https://cdn.faire.com/fastly/2e95f6752e31970ef6fa49d2ab92aee7a12eac48b889d247f2125dc86b7d4213.png",
          }}
        />
      }
      subtitle={
        <>
          <StrictLocalMsg
            defaultMessage="This product is no longer available or has been removed."
            description={{
              text: "Subtitle for a product not found",
              img: "https://cdn.faire.com/fastly/499506faf1f3c5cb7555d006fa8076ba29006268767968a7158203c4059ae92c.png",
            }}
          />
          <br />
          <StrictLocalMsg
            defaultMessage="Don’t fret—there’s more to explore."
            description={{
              text: "Subtitle for a product not found",
              img: "https://cdn.faire.com/fastly/499506faf1f3c5cb7555d006fa8076ba29006268767968a7158203c4059ae92c.png",
            }}
          />
        </>
      }
      trackingContainerName="pdp_not_found_category_grid"
    />
  );
};
